import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  withStyles,
  Typography,
  ListItem,
  Avatar,
  // Hidden,
} from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person'
import classNames from 'classnames'
import { read } from 'actions/data'
import {
  selectConversation,
  toggleChatSearch,
  changeTo,
} from 'actions/inbox'
import { deleteContact, getContact } from 'actions/contacts'
import { selectContact } from 'actions/contacts/addOrEdit'
import {
  addContactsToGroup,
  removeContactsFromGroup,
} from 'actions/contacts/groups'
import { updateContactWithUser } from 'actions/roundRobin'
import { detail } from './index'
import styles from './styles'
import { toggleDialog } from 'actions/view'
import { setMergeFieldsPreviewSelect } from 'actions/tasks'

export default connect(
  (state, { contact }) => ({
    selected: Boolean(state.contacts.selectedContacts?.[contact?.id]),
    // assigningIndividualContacts: state.sort?.userAssignment === 'contact/a2',
    currentUser: state?.auth?.session?.idToken?.payload?.['cognito:username'],
    users: state.data?.['account/user'] || {},
    update_contacts:
      state.data?.['account/preference']?.preferences?.update_contacts,
    vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
    vastuser: state.contacts.contactsWithEmailsByID?.[contact?.id]?.vastuser,
    enabled: state.data?.['account/ap/status']?.enabled,
    type: state.view.dialogs?.contactList?.type,
  }),
  dispatch =>
    bindActionCreators(
      {
        deleteContact,
        addContactsToGroup,
        removeContactsFromGroup,
        selectContact,
        getContact,
        updateContactWithUser,
        read,
        selectConversation,
        toggleChatSearch,
        changeTo,
        toggleDialog,
        setMergeFieldsPreviewSelect,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class PanelComponent extends Component {
      state = {
        value: 'unassigned',
      }

      componentDidUpdate(prevProps) {
        if (
          this.props.assigningIndividualContacts &&
          prevProps.assigningIndividualContacts !==
            this.props.assigningIndividualContacts
        ) {
          this.setState({ value: 'unassigned' })
        }
      }

      render() {
        const {
          classes,
          contact,
          selected,
          // enabled,
          // vastuser,
          selectConversation,
          toggleChatSearch,
          changeTo,
          read,
          type,
          toggleDialog,
          setMergeFieldsPreviewSelect,
          isPinned,
        } = this.props

        // const detailText =
        //   contact?.first_name || contact?.middle_name || contact?.last_name
        //     ? detail(contact)
        //     : ''

        const name =
          contact?.first_name || contact?.middle_name || contact?.last_name
            ? `${contact?.first_name ? `${contact?.first_name} ` : ''}${
                contact?.middle_name ? `${contact?.middle_name} ` : ''
              }${contact?.last_name ? `${contact?.last_name} ` : ''}`
            : detail(contact)

        const nameTypography = (
          <Typography noWrap className={classes.heading}>
            {isPinned ? '📌 ' : ''}{name}
          </Typography>
        )

        // const detailTypography = (
        //   <Typography
        //     noWrap
        //     className={
        //       enabled || vastuser
        //         ? classes.secondaryHeadingWhenAssigningUsers
        //         : classes.secondaryHeading
        //     }
        //   >
        //     {detailText}
        //     {detailText && contact?.location
        //       ? ' | ' + contact?.location
        //       : contact?.location || ''}
        //   </Typography>
        // )

        // const detailTypographyComponent = (
        //   <Hidden smDown>{detailTypography}</Hidden>
        // )

        const typeActionObj = {
          inbox: () =>
            Promise.resolve(toggleChatSearch(false))
              .then(() => selectConversation(null))
              .then(() => {
                read(contact?.id, 'inbox', 'inbox/conversation', 'contact_id')
                  .then(() =>
                    toggleDialog({
                      open: false,
                      dialog: 'contactList',
                      options: { type: null },
                    }),
                  )
                  .then(() => selectConversation(contact?.id))
                  .then(() => changeTo(''))
              }),
          template: () => {
            setMergeFieldsPreviewSelect({
              contactID: contact.id,
              value: contact.id,
              label: name,
              key: `${contact.id}SelectValue`,
            })
            toggleDialog({
              open: false,
              dialog: 'contactList',
              options: { type: null },
            })
          },
        }

        return (
          <ListItem
            className={classNames(
              classes.panelModal,
              'contact-expansion-panel',
            )}
            button
            onClick={() => typeActionObj?.[type]?.()}
            classes={{
              container: classes.container,
            }}
          >
            <div className={classes.panelContentModal}>
              <div className={classes.left}>
                <Avatar
                  style={selected ? { display: 'none' } : null}
                  classes={{
                    root: classes.avatarRoot,
                    colorDefault: classes.colorDefault,
                  }}
                >
                  {contact?.first_name ||
                  contact?.middle_name ||
                  contact?.last_name ? (
                    `${
                      contact?.first_name
                        ? `${contact?.first_name.slice(0, 1)}`
                        : ''
                    }${
                      contact?.middle_name &&
                      (!contact?.first_name || !contact?.last_name)
                        ? `${contact?.middle_name.slice(0, 1)}`
                        : ''
                    }${
                      contact?.last_name
                        ? `${contact?.last_name.slice(0, 1)}`
                        : ''
                    }`
                  ) : (
                    <PersonIcon />
                  )}
                </Avatar>
              </div>
              {nameTypography}
              {/* {detailText || contact?.location
                ? detailTypographyComponent
                : null} */}
            </div>
          </ListItem>
        )
      }
    },
  ),
)
